export const operations = {
  read: 'read',
  update: 'update',
  delete: 'delete',
  create: 'create',
};
